import { Products, ProductCardDataFragment } from "lib/graphql-generated";
import currency from "currency.js";
import { Button } from "./buttons/button";
import Link from "next/link";
import { gql } from "@apollo/client";
import { AddToBasket } from "./buttons/add-to-basket";
import { IBasketItem } from "lib/basket/types";

const PRODUCT_CARD_FRAGMENT = gql`
  fragment ProductCardData on products {
    id
    image
    price
    title
    slug
    stock
    is_discounted
    discount_value
  }
`;
interface Props {
  product: ProductCardDataFragment;
  className?: string;
}
export const ProductCard = ({ product, className }: Props) => {
  const payload: IBasketItem<"product"> = {
    type: "product",
    id: product.id,
    data: {
      quantity: 1,
      price: product.price,
      discount: product.is_discounted ? product.discount_value : 0,
      product: {
        title: product.title,
        id: product.id,
        image: product.image,
      },
    },
  };

  return (
    <article
      className={`group flex flex-col max-w-2xs ${className} cursor-pointer`}>
      <Link href={`/shop/${product.slug}`}>
        <a className='flex flex-col flex-1'>
          <img
            src={product.image}
            alt={`Image for ${product.title}`}
            className='group-hover:-translate-y-1 transform ease-in transition-transform min-h-60 bg-green-light text-white'
          />
          <header className='pt-4 mt-auto'>
            <h1 className='header text-xl group-hover:text-red-dark'>
              {product.title}
            </h1>
          </header>
        </a>
      </Link>
      <section className='flex flex-row flex-wrap  border-gray-300  justify-between'>
        <hr className='bg-gray-300 w-full h-4 mb-2' />
        <span className='group-hover:text-red-dark'>
          {currency(product.price, { fromCents: true, symbol: "£" }).format()}
        </span>
        <AddToBasket buttonType='primary' buttonSize='sm' payload={payload}>
          Add to basket
        </AddToBasket>
      </section>
    </article>
  );
};
